import { render } from "./MCheckboxGroup.vue?vue&type=template&id=119f10a0"
import script from "./MCheckboxGroup.vue?vue&type=script&lang=js"
export * from "./MCheckboxGroup.vue?vue&type=script&lang=js"

import "./MCheckboxGroup.vue?vue&type=style&index=0&id=119f10a0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__